import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Prevent service worker from interfering in Lovable preview/iframe
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

// Render the app first — observability is deferred so it never blocks LCP/TTI.
createRoot(document.getElementById("root")!).render(<App />);

// Defer Sentry init until the browser is idle (error monitoring, fully masked, no PII).
// PostHog & Google Analytics are loaded only after cookie consent (see src/lib/consent.ts).
const bootObservability = () => {
  import("./lib/sentry")
    .then((sentry) => sentry.initSentry())
    .catch(() => {
      // Observability is best-effort — failures must not affect the app.
    });
  import("./lib/consent")
    .then((consent) => consent.initConsent())
    .catch(() => {
      /* best-effort */
    });
};


if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    (window as Window & { requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => void }).requestIdleCallback(
      bootObservability,
      { timeout: 4000 },
    );
  } else {
    setTimeout(bootObservability, 2500);
  }
}
